<div class="mat-typography">
    <div class="mat-typography content">
        <h4 class="header">General statistic</h4>
        <p>Total Datasets Cached: {{ cacheIteratorStatistic?.totalDataSetsCached }}</p>
        <p>Total Data Load Duration (s): {{
            millisecondsToSeconds(cacheIteratorStatistic?.totalDataLoadDuration) }} ({{
            getTime(millisecondsToSeconds(cacheIteratorStatistic?.totalDataLoadDuration)) }})</p>

        <h4 class="header">Requests to Zoning Service statistic</h4>
        <p>Total PR requests: {{ cacheIteratorStatistic?.totalPRRequestsCount }}</p>
        <p>Total Street requests: {{ cacheIteratorStatistic?.totalStreetRequestsCount }}</p>
        <p>Total PR Tags requests: {{ cacheIteratorStatistic?.totalPRTagsRequestsCount }}</p>

        <h4 class="header">Entities statistic</h4>
        <table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp">
            <thead>
                <tr>
                    <th class="header-cell">Entity type</th>
                    <th class="header-cell">Desired</th>
                    <th class="header-cell">Cached<br>(% of desired)</th>
                    <th class="header-cell">Requested to GAPI<br>(% of desired)</th>
                    <th class="header-cell">Received from GAPI<br>(% of requested)</th>
                    <th class="header-cell">Missed<br>(% of requested)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Property Record</td>
                    <td>{{ cacheIteratorStatistic?.totalDesiredPRsCount }}</td>
                    <td>{{ cacheIteratorStatistic?.totalCachedPropertyRecordsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalCachedPropertyRecordsCount,cacheIteratorStatistic?.totalDesiredPRsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalRequestedPropertyRecordsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedPropertyRecordsCount,cacheIteratorStatistic?.totalDesiredPRsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalReceivedPropertyRecordsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalReceivedPropertyRecordsCount,cacheIteratorStatistic?.totalRequestedPropertyRecordsCount)}}%)
                    </td>
                    <td>{{cacheIteratorStatistic?.totalRequestedPropertyRecordsCount-cacheIteratorStatistic?.totalReceivedPropertyRecordsCount}}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedPropertyRecordsCount-cacheIteratorStatistic?.totalReceivedPropertyRecordsCount,cacheIteratorStatistic?.totalRequestedPropertyRecordsCount)}}%)
                    </td>
                </tr>
                <tr>
                    <td>Abutting Property Record</td>
                    <td>{{ cacheIteratorStatistic?.totalDesiredAbuttingPRsCount }}</td>
                    <td>{{ cacheIteratorStatistic?.totalCachedAbuttingPRsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalCachedAbuttingPRsCount,cacheIteratorStatistic?.totalDesiredAbuttingPRsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalRequestedAbuttingPRsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedAbuttingPRsCount,cacheIteratorStatistic?.totalDesiredAbuttingPRsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalReceivedAbuttingPRsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalReceivedAbuttingPRsCount,cacheIteratorStatistic?.totalRequestedAbuttingPRsCount)}}%)
                    </td>
                    <td>{{cacheIteratorStatistic?.totalRequestedAbuttingPRsCount-cacheIteratorStatistic?.totalReceivedAbuttingPRsCount}}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedAbuttingPRsCount-cacheIteratorStatistic?.totalReceivedAbuttingPRsCount,cacheIteratorStatistic?.totalRequestedAbuttingPRsCount)}}%)
                    </td>
                </tr>
                <tr>
                    <td>Street</td>
                    <td>{{ cacheIteratorStatistic?.totalDesiredStreetsCount }}</td>
                    <td>{{ cacheIteratorStatistic?.totalCachedStreetsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalCachedStreetsCount,cacheIteratorStatistic?.totalDesiredStreetsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalRequestedStreetsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedStreetsCount,cacheIteratorStatistic?.totalDesiredStreetsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalReceivedStreetsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalReceivedStreetsCount,cacheIteratorStatistic?.totalRequestedStreetsCount)}}%)
                    </td>
                    <td>{{cacheIteratorStatistic?.totalRequestedStreetsCount-cacheIteratorStatistic?.totalReceivedStreetsCount}}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedStreetsCount-cacheIteratorStatistic?.totalReceivedStreetsCount,cacheIteratorStatistic?.totalRequestedStreetsCount)}}%)
                    </td>
                </tr>
                <tr>
                    <td>Property Record Tag</td>
                    <td>{{ cacheIteratorStatistic?.totalDesiredPRTagsCount }}</td>
                    <td>{{ cacheIteratorStatistic?.totalCachedPRTagsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalCachedPRTagsCount,cacheIteratorStatistic?.totalDesiredPRTagsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalRequestedPRTagsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedPRTagsCount,cacheIteratorStatistic?.totalDesiredPRTagsCount)}}%)
                    </td>
                    <td>{{ cacheIteratorStatistic?.totalReceivedPRTagsCount }}
                        ({{getPercent(cacheIteratorStatistic?.totalReceivedPRTagsCount,cacheIteratorStatistic?.totalRequestedPRTagsCount)}}%)
                    </td>
                    <td>{{cacheIteratorStatistic?.totalRequestedPRTagsCount-cacheIteratorStatistic?.totalReceivedPRTagsCount}}
                        ({{getPercent(cacheIteratorStatistic?.totalRequestedPRTagsCount-cacheIteratorStatistic?.totalReceivedPRTagsCount,cacheIteratorStatistic?.totalRequestedPRTagsCount)}}%)
                    </td>
                </tr>
                <tr>
                    <td>Totals</td>
                    <td>{{getTotalDesiredEntities()}}</td>
                    <td>{{getTotalCachedEntities()}} ({{getAVGCacheUsage()}}%)</td>
                    <td>{{getTotalRequestedEntities()}} ({{getAVGRequestedData()}}%)</td>
                    <td>{{getTotalReceivedEntities()}} ({{getAVGReceivedData()}}%)</td>
                    <td>{{getTotalMissedEntities()}} ({{getAVGMissedData()}}%)</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
